<div class="property-update-container">
  <div mat-dialog-title class="mb-2">{{type === types.UPDATE ? 'Update property' : 'Create new property'}}</div>
  <mat-dialog-content class="my-3 d-flex flex-column">
    <mat-form-field>
      <input [(ngModel)]="key" matInput type="text" name="key" placeholder="Key" required>
    </mat-form-field>

    <mat-form-field>
      <input [(ngModel)]="value" matInput type="text" name="value" placeholder="Value" required>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-content-end">
    <button mat-raised-button color="primary" (click)="save()">Save</button>
    <button mat-button (click)="closeDialog()">Cancel</button>
  </mat-dialog-actions>
</div>


